// extracted by mini-css-extract-plugin
export default {"status":"shift-pwa-controls_status__i5535","instructions":"shift-pwa-controls_instructions__xheIO"};